import React from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import grey from "@material-ui/core/colors/grey";

const styles = theme => ({
  brandSafetyIcon: {
    display: "inline-block"
  },
  character: {
    fill: grey[50],
    fontSize: 50,
    fontFamily: theme.typography.fontFamily,
    fontWeight: "600"
  },
  suitableSome: {
    fill: theme.brandSafety ? theme.brandSafety.suitableSome : ""
  },
  suitableMost: {
    fill: theme.brandSafety ? theme.brandSafety.suitableMost : ""
  },
  unsuitable: {
    fill: theme.brandSafety ? theme.brandSafety.unsuitable : ""
  },
  notRated: {
    fill: theme.brandSafety ? theme.brandSafety.notRated : ""
  },
  zeroTolerance: {
    fill: theme.brandSafety ? theme.brandSafety.zeroTolerance : ""
  },
  svgContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

class OSSBrandSafetyIcon extends React.Component {
  getBrandSafetyOptions(character) {
    var brandSafetyOptions = {};

    switch (character) {
      case "MS":
        brandSafetyOptions = {
          class: "suitableSome"
        };
        break;
      case "GS":
        brandSafetyOptions = {
          class: "suitableMost"
        };
        break;
      case "NS":
        brandSafetyOptions = {
          class: "unsuitable"
        };
        break;
      case "NR":
        brandSafetyOptions = {
          class: "notRated"
        };
        break;
      case "X":
        brandSafetyOptions = {
          class: "zeroTolerance"
        };
        break;
      default:
        brandSafetyOptions = {
          class: "notRated"
        };
        break;
    }

    return brandSafetyOptions;
  }

  formatCharacter(character) {
    var formattedCharacter = "";

    if (character) {
      formattedCharacter = character;

      // Force only one character
      if (character.length > 1) {
        formattedCharacter = character.charAt(0);
      }

      // Convert to uppercase
      formattedCharacter = formattedCharacter.toUpperCase();
    }

    return formattedCharacter;
  }

  render() {
    const { classes, width, character, fill } = this.props;
    const newWidth = width ? width : 53.12;
    const newHeight = width ? width * 1.2 : 64;
    const suitabilityOptions = this.getBrandSafetyOptions(character);
    const formattedCharacter = this.formatCharacter(character);

    return (
      <div className={classes.brandSafetyIcon}>
        <div className={classes.svgContainer}>
          <svg
            className={classes[suitabilityOptions.class]}
            style={{ fill: fill ? fill : "" }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 87 100"
            width={newWidth}
            height={newHeight}>
            <title>Brand Saftey Icon</title>
            <path
              x="0"
              y="0"
              d="M38.971 2.5q4.33-2.5 8.66 0l34.641 20q4.33 2.5 4.33 7.5v40q0 5-4.33 7.5l-34.64 20q-4.33 2.5-8.66 0L4.33 77.5Q0 75 0 70V30q0-5 4.33-7.5z"
            />
            <text
              className={classes.character}
              x="50%"
              y="50%"
              dy="0.36em"
              textAnchor="middle">
              {formattedCharacter}
            </text>
          </svg>
        </div>
      </div>
    );
  }
}

OSSBrandSafetyIcon.propTypes = {
  width: PropTypes.number,
  fill: PropTypes.string,

  // Custom prop validation: must be string with max length of 1.
  character: (props, propName, componentName) => {
    if (
      props[propName] &&
      typeof props[propName] === "string" &&
      !/^.{1}$/.test(props[propName])
    ) {
      return new Error(
        `Invalid prop ${propName} supplied to ${componentName}. Validation failed: character prop accepts string with max length of 1.`
      );
    }
  }
};
OSSBrandSafetyIcon.defaultProps = {
  character: ""
};

export default withStyles(styles)(OSSBrandSafetyIcon);
